import { apiClient } from "./client";
import { getGuestId } from "../utils/guest";

function readPayload(payload) {
  if (payload?.data) {
    return payload.data;
  }

  return payload || {};
}

export async function createPaymentIntent(payload) {
  const response = await apiClient.post(
    process.env.REACT_APP_PAYMENT_INTENT_ENDPOINT || "/api/Payment/CreateGuestPaymentIntent",
    payload
  );

  return readPayload(response.data);
}

export async function placeOrder(payload) {
  const response = await apiClient.post(
    process.env.REACT_APP_PLACE_ORDER_ENDPOINT || "/api/Products/GuestCheckout",
    payload
  );

  return readPayload(response.data);
}

export async function createGuestPaymentIntent(pickupId, warehouse = "") {
  const payload = await createPaymentIntent({
    GuestId: getGuestId(),
    PickupID: pickupId,
    Warehouse: warehouse,
  });

  if (String(payload.ResponseCode || "") !== "200") {
    throw new Error(payload.Message || "Payment could not be started.");
  }

  return payload.Result || {};
}

export async function downloadGuestPlatterOrderConfirmation(orderNumber) {
  return apiClient.get(
    process.env.REACT_APP_GUEST_ORDER_CONFIRMATION_ENDPOINT ||
      "/api/Products/DownloadGuestPlatterOrderConfirmation",
    {
      params: { orderNumber },
      responseType: "blob",
    }
  );
}
